import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'
interface CreateRequestEditParams {
  requestChange: string
}
export function useCreateEditAgreement(id_agreement?: string) {
  const queryClient = useQueryClient()
  const token = useAccessToken()
  return useMutation({
    mutationFn: async ({ requestChange }: CreateRequestEditParams) => {
      if (!requestChange) {
        throw new Error('Campos obrigatórios ausentes')
      }

      const response = await api.post(
        `/agreement-edit/request/${id_agreement}`,
        { requestChange },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )

      if (!response.data) {
        throw new Error('Erro ao solicitar alteração de Minuta')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
